import * as React from 'react';
import { Overlay } from '../components/Overlay';
import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import { selectLocalFiles } from '../utils';
import { OverlayOption, OverlayOptions } from '../components/OverlayOptions';
import FileType from '../data/FileType';
import { useMobileLayout } from 'hooks/useMobileLayout';

export const SoundtrackSelectionOverlay: React.FunctionComponent = () => {
  const didChooseOption = async (key: string) => {
    console.log('Option: ' + key);
    switch (key) {
      case 'loop':
        storeDispatch(Actions.showGenreSelector());
        break;
      case 'itunes':
        storeDispatch(Actions.showITunesSearch());
        break;
      case 'pc':
      case 'deviceSong':
        const files = await selectLocalFiles(FileType.Audio);
        if (files.length) {
          storeDispatch(Actions.addAudioFile(files[0]));
        }
        break;
      default:
        break;
    }
  };

  const isMobile = useMobileLayout();

  const items: OverlayOption[] = [
    {
      key: 'loop',
      title: 'Royalty-free soundtracks',
      description:
        'Share the video wherever you want without worrying about permissions.',
      cta: 'Select track'
    },
    {
      key: 'itunes',
      title: 'Song from Apple Music',
      description:
        'Access to the video may get restricted depending on the network.',
      cta: 'Search any song'
    },
    {
      key: isMobile ? 'deviceSong' : 'pc',
      title: `File on your ${isMobile ? 'device' : 'PC'}`,
      description:
        'You will need the author’s permission\nif you want to share it online.',
      cta: 'Select audio file',
      footer: (
        <>
          Supported: <strong>.wav</strong>, <strong>.mp3</strong> and{' '}
          <strong>.m4a</strong>
        </>
      )
    }
  ];

  return (
    <Overlay title="Choose soundtrack">
      <OverlayOptions items={items} onSelect={didChooseOption} />
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/onboarding/SoundtrackTypeSelectionOverlay.tsx